import { render, staticRenderFns } from "./DynamicTemplateApp.vue?vue&type=template&id=7cf4a5a5&scoped=true"
import script from "./DynamicTemplateApp.vue?vue&type=script&lang=js"
export * from "./DynamicTemplateApp.vue?vue&type=script&lang=js"
import style0 from "./DynamicTemplateApp.vue?vue&type=style&index=0&id=7cf4a5a5&prod&lang=scss"
import style1 from "./DynamicTemplateApp.vue?vue&type=style&index=1&id=7cf4a5a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf4a5a5",
  null
  
)

export default component.exports